import { guides } from "@/mocks/melon";

function Guide() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">Be a Smart Scooper</p>
          <h2 className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            吃瓜生存指南
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            瓜吃得热闹，也别忘了吃得明白。四条心法，让你在瓜田里既尽兴又清醒。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guides.map((g, i) => (
            <article
              key={g.title}
              className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-6 transition-colors hover:border-accent-300 hover:bg-background-50"
            >
              <div className="absolute right-4 top-4 font-heading text-4xl font-black text-background-200">
                {String(i + 1).padStart(2, "0")}
              </div>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                <i className={g.icon} />
              </span>
              <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{g.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Guide;